import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { BASE_URL } from "../../Const/Url";
import { logout_func2 } from "../../Const/logoutCommon";
import { showToast } from "../../../utils/ToastHelper";
import Loader from "../../CustomCommons/Loader";

const ViewCorporateOrder = () => {
  const history = useHistory();
  const { id:number } = useParams();

  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchOrderDetails = useCallback(() => {
    if (!number) {
      showToast("error", "Missing order number.");
      history.push("/corporate/order-list");
      return;
    }

    setIsLoading(true);
    axios
      .get(`${BASE_URL}api/v1/frontend/admin/v2/corporate-orders/${number}/`)
      .then((res) => {
        const data = res?.data?.data;
        if (!data) {
          showToast("error", "Failed to load corporate order details.");
          history.push("/corporate/order-list");
          return;
        }
        setOrder(data);
      })
      .catch((err) => {
        const message = err?.response?.data?.message;
        const status = err?.response?.status;

        if (message === "Invalid token." || status === 401) {
          logout_func2(() => {}, history);
          return;
        }
        showToast(
          "error",
          message || "Failed to load corporate order details."
        );
        history.push("/corporate/order-list");
      })
      .finally(() => setIsLoading(false));
  }, [number, history]);

  useEffect(() => {
    fetchOrderDetails();
  }, [fetchOrderDetails]);

  const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  if (!order) {
    return null;
  }

  return (
    <div className="categorey-parent">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Corporate Order Details
          </h3>
          <button
            className="btn btn-outline-dark btn-sm"
            onClick={() => history.goBack()}
          >
            Back
          </button>
        </div>

        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
        >
          <div className="row mb-4">
            <div className="col-12 col-md-4 mb-3">
              <h6>Order Number</h6>
              <p className="mb-0">{order?.number || "-"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Created At</h6>
              <p className="mb-0">{formatDate(order?.created_at)}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Customer Name</h6>
              <p className="mb-0">{order?.customer_name || "-"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Company Name</h6>
              <p className="mb-0">{order?.company_name || "-"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Address</h6>
              <p className="mb-0">{order?.address || "-"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Subtotal</h6>
              <p className="mb-0">{order?.subtotal || "0.00"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Shipping</h6>
              <p className="mb-0">{order?.shipping || "0.00"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Discount</h6>
              <p className="mb-0">{order?.discount || "0.00"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Total</h6>
              <p className="mb-0 fw-bold">{order?.total || "0.00"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Paid Amount</h6>
              <p className="mb-0">{order?.paid_amount || "0.00"}</p>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <h6>Due Amount</h6>
              <p className="mb-0">{order?.due_amount || "0.00"}</p>
            </div>
          </div>

          <h5 className="mt-3 mb-2">Items</h5>
          <div style={{ display: "block", overflowX: "auto" }}>
            <table className="table_my pdf-table my-3">
              <thead
                className="bg-dark text-white head-row mt-3 main-head-print"
                style={{ height: "45px" }}
              >
                <tr>
                  <th style={{ width: "80px", textAlign: "center" }}>#</th>
                  <th style={{ minWidth: "120px" }}>Product Name</th>
                  <th style={{ minWidth: "140px" }}>Variant Name</th>
                  <th style={{ minWidth: "120px" }}>Quantity</th>
                  <th style={{ minWidth: "140px" }}>Total Price</th>
                </tr>
              </thead>
              <tbody className="tb">
                {order?.items?.length ? (
                  order.items.map((item, index) => (
                    <tr key={item?.id || index} className="table-row">
                      <td className="text-center">{index + 1}</td>
                      <td>{item?.product_details?.name ?? "-"}</td>
                      <td>{item?.varient_details?.name ?? "-"}</td>
                      <td>{item?.product_quantity ?? "-"}</td>
                      <td>{item?.total_price ?? "0.00"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <div className="not_found d-flex justify-content-center align-items-center py-3">
                        <h5 className="my-2">No Items Found</h5>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCorporateOrder;
